import {TextField} from '@/components/atoms'
import {getDefaultQuantity} from '@/utils/productCombo/productComboValidation'
import {Counter} from 'pepsico-ds'
import {memo, useCallback} from 'react'

/**
 * @param {{
 *   product: import('@/types/productComboTypes').ProductListingItem,
 *   onUpdateProductQuantity: (productId: string, quantity: number) => void,
 * }} props
 */
const ComboProductQuantityRowComponent = ({product, onUpdateProductQuantity}) => {
  const sellingUnits = getDefaultQuantity(product.multipleSellingUnits)

  const handleUpdateQuantity = useCallback(
    newValue => {
      const nextValue = Number(newValue)
      const currentQuantity = Number(product.quantity) || sellingUnits

      if (Number.isNaN(nextValue) || nextValue === currentQuantity) {
        return
      }

      const updatedQuantity =
        nextValue > currentQuantity
          ? currentQuantity + sellingUnits
          : Math.max(sellingUnits, currentQuantity - sellingUnits)

      onUpdateProductQuantity(product.productId, updatedQuantity)
    },
    [onUpdateProductQuantity, product.productId, product.quantity, sellingUnits]
  )

  return (
    <div className="flex items-center gap-6">
      <TextField uiSchema={{className: 'w-[300px]'}} label="Product Name" value={product.productName} disabled={true} />
      <div className="mb-2 w-[140px]">
        <div className="label-element $font-body-regular" data-testid="label">
          <span className="label-text $font-xsmall-regular">
            <label>Quantity*</label>
          </span>
        </div>
        <Counter
          label="Quantity*"
          value={product.quantity}
          minValue={sellingUnits}
          maxValue={999}
          onUpdate={handleUpdateQuantity}
        />
      </div>
    </div>
  )
}

export const ComboProductQuantityRow = memo(ComboProductQuantityRowComponent)
